import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/manufacturers/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/manufacturers/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/manufacturers/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/manufacturers/delete',
    method: 'post',
    data
  })
}

